import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, catchError, from, map, of, switchMap, take } from "rxjs";
import { DemoInstancesService } from "../services/demo-instances.service";
import { DemoInstance, PowerState } from "../core";
import { confirm } from "devextreme/ui/dialog";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "brd-action",
  templateUrl: "./action.component.html",
  styleUrls: ["./action.component.less"]
})
export class ActionComponent {
  private action = "";
  private target = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private demoInstancesService: DemoInstancesService
  ) {
    this.route.queryParams
      .pipe(
        takeUntilDestroyed(),
        switchMap(params => {
          this.action = params.action;
          this.target = params.target;

          return this.demoInstancesService.getHomeDemos();
        }),
        take(1),
        switchMap(instances => {
          let result$: Observable<DemoInstance>;
          if (instances?.length > 0) {
            const instance = instances.find(r => r.name === this.target);
            if (instance) {
              switch (this.action) {
                case "activate":
                  if (instance.powerState === PowerState.Offline) {
                    result$ = this.demoInstancesService.restartDemoInstanceById(instance.id);
                  }
                  break;
                case "delete":
                  if (instance.powerState !== PowerState.Deleting) {
                    const res = confirm(`Are you sure to delete <strong>${instance.name}</strong>?`, "Deletion").then(dialogResult => {
                      if (dialogResult) {
                        return this.demoInstancesService.deleteDemoInstance(instance.id);
                      } else {
                        return of(null);
                      }
                    });
                    result$ = from(res).pipe(switchMap(r => r));
                  }
                  break;
                case "stop":
                  if (instance.powerState !== PowerState.Offline) {
                    const res = confirm(
                      `Are you sure to put the demo <strong>${instance.name}</strong> into sleep mode?`,
                      "Sleep mode"
                    ).then(dialogResult => {
                      if (dialogResult) {
                        return this.demoInstancesService.stopDemoInstance(instance.id);
                      } else {
                        return of(null);
                      }
                    });
                    result$ = from(res).pipe(switchMap(r => r));
                  }
                  break;
                default:
                  break;
              }
            }
          }
          return result$;
        }),
        map(r => {
          console.log(r);
          this.redirectHomePage();
        }),
        catchError(err => {
          this.redirectHomePage();
          return err;
        })
      )
      .subscribe();
  }

  redirectHomePage(): void {
    this.router.navigate(["/"]);
  }
}
